import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import LabeledInput from 'modules/core/components/LabeledInput'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  onChange: (levels: string[]) => void
}

const LevelsInput: React.FC<Props> = ({ onChange }) => {
  const [levels, setLevels] = React.useState<string[]>([])

  const items = levels.map((_, i) => {
    const handleDelete = () => {
      const nextLevels = levels.filter((_, ii) => i !== ii)

      setLevels(nextLevels)
      onChange(nextLevels)
      track(trackingEvents.jobCatalog.deleteNewJobLevelSubmit)
    }

    const handleChange = (change: string) => {
      const nextLevels = levels.slice()
      nextLevels[i] = change

      setLevels(nextLevels)
      onChange(nextLevels.filter((x) => x.trim() !== ''))
      track(trackingEvents.jobCatalog.createNewJobLevelSubmit)
    }

    return <Item key={i} onChange={handleChange} onDelete={handleDelete} />
  })

  const handleAddLevel = () => {
    setLevels([...levels, ''])
    track(trackingEvents.jobCatalog.createNewJobAddLevelSubmit)
  }

  return (
    <Box paddingBottom="s24">
      <LabeledInput label={i18n.t('job_catalog.levels')} isLegend>
        {items.length > 0 ? items : <Box paddingBottom="s16" gap="s8" />}
        <Button
          onClick={handleAddLevel}
          type="secondary"
          iconName="add"
          extra={{
            'data-intercom-target': 'job-catalog-new-job-levels-input-add-level-button',
          }}
        >
          {i18n.t('job_catalog.add_level')}
        </Button>
      </LabeledInput>
    </Box>
  )
}

export default observer(LevelsInput)
